export const agendaDetail = {
    '6月24日': [
        {
            id: '001',
            title: '开幕式与未来峰会',
            description:'当前人工智能步入规模化落地周期，智能体在重塑各行业生产力范式的同时，彻底改写传统安全对抗逻辑。ISC.AI 2026 开幕式与未来峰会聚焦安全对抗由“人对人”转向“AI对AI”的核心变革，汇聚全球产业领袖与学界专家，深入剖析智能体技术演进引发的安全挑战及应对策略，共同探索安全智能体的创新发展路径，引领行业革命性突破。',
            start_date: '2026-06-24 09:00:00',
            end_date: '2026-06-24 12:15:00',
            address: '北京国家会议中心4F大会堂A',
            activity_type: '未来峰会',
            meet_date: '2026-06-24',
            date_type: '上午',
            video_url: 'https://isc.360.com/2020/detail.html？vid=6842',
            isShowDetail: true,
            agendas: [
                {
                    start_time: '09:00:00',
                    end_time: '09:10:00',
                    title: '纳米大片流水线——微电影《七色图腾》',
                    speakers: []
                },
                {
                    start_time: '09:10:00',
                    end_time: '09:15:00',
                    title: '领导致辞',
                    speakers: [
                        {
                            name: '李冰',
                            is_compere: 0,
                            bio: '全国工商联党组成员、副主席',
                            image_url: ''
                        }
                    ]
                },
                {
                    start_time: '09:15:00',
                    end_time: '09:20:00',
                    title: '领导致辞',
                    speakers: [
                        {
                            name: '任贤良',
                            is_compere: 0,
                            bio: '第十三届全国人大社会建设委员会副主任委员、国家互联网信息办公室原副主任、世界互联网大会秘书长',
                            image_url: ''
                        }
                    ]
                },
                {
                    start_time: '09:20:00',
                    end_time: '09:25:00',
                    title: '领导致辞',
                    speakers: [
                        {
                            name: '赵志国',
                            is_compere: 0,
                            bio: '中国互联网协会副理事长、工业和信息化部原总工程师',
                            image_url: ''
                        }
                    ]
                },
                {
                    start_time: '09:25:00',
                    end_time: '09:30:00',
                    title: '领导致辞',
                    speakers: [
                        {
                            name: '韩雪',
                            is_compere: 0,
                            bio: '北京市朝阳区委常委、统战部部长，区社会主义学院院长，区政协党组副书记（兼）',
                            image_url: 'https://p5.ssl.qhimg.com/t110b9a930191549f74f1fa191c.jpg'
                        }
                    ]
                },
                {
                    start_time: '09:30:00',
                    end_time: '09:35:00',
                    title: '领导致辞',
                    speakers: [
                        {
                            name: '邬贺铨',
                            is_compere: 0,
                            bio: 'ISC.AI名誉主席、教授',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a93019d7c8cd9929d7c13.png'
                        }
                    ]
                },
                {
                    start_time: '09:35:00',
                    end_time: '09:55:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '赵春江',
                            is_compere: 0,
                            bio: '中国工程院院士、国家新一代人工智能战略咨询委员会委员、中国人工智能学会党委书记、副理事长',
                            image_url: 'https://p4.ssl.qhimg.com/t110b9a9301cc4649daabea1bfa.jpg'
                        }
                    ]
                },
                {
                    start_time: '09:55:00',
                    end_time: '10:40:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '周鸿祎',
                            is_compere: 0,
                            bio: '360集团创始人、ISC.AI大会主席',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a93012806bea6994f3ca7.png'
                        }
                    ]
                },
                {
                    start_time: '10:40:00',
                    end_time: '10:45:00',
                    title: '仪式发布——“磐石之盾”安全协作计划	',
                    speakers: []
                },
                {
                    start_time: '10:45:00',
                    end_time: '11:05:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '张为志',
                            is_compere: 0,
                            bio: '经济哲学、科学哲学研究专家，国际欧亚科学院通讯院士',
                            image_url: 'https://p4.ssl.qhimg.com/t110b9a9301d6835e2db823a282.jpg'
                        }
                    ]
                },
                {
                    start_time: '11:05:00',
                    end_time: '11:10:00',
                    title: '专题报告——信通院&360《企业级智能体技术与应用研究报告》',
                    speakers: []
                },
                {
                    start_time: '11:10:00',
                    end_time: '11:25:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '张云勇',
                            is_compere: 0,
                            bio: '第十三届全国政协委员、中国联通集团网络与信息安全部总经理',
                            image_url: 'https://p1.ssl.qhimg.com/t110b9a93015e4dd11f536c870c.jpg'
                        }
                    ]
                },
                {
                    start_time: '11:25:00',
                    end_time: '11:45:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '韩国华',
                            is_compere: 0,
                            bio: 'IDC中国区副总裁',
                            image_url: 'https://p4.ssl.qhimg.com/t110b9a93010d85f6428ef67c1a.png'
                        }
                    ]
                },
                {
                    start_time: '11:45:00',
                    end_time: '11:55:00',
                    title: '颁奖环节——IDC 2026 城市 AI 创新力榜单',
                    speakers: []
                },
                {
                    start_time: '11:55:00',
                    end_time: '12:15:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: 'Timothy Lee',
                            is_compere: 0,
                            bio: 'Founder & Principal Consultant · YUZANA LLC',
                            image_url: 'https://p4.ssl.qhimg.com/t110b9a9301923aa4fbe8b735f4.jpg'
                        }
                    ]
                },
            ]
        },
        {
            id: '002',
            title: '未来峰会',
            description:'当前人工智能步入规模化落地周期，智能体在重塑各行业生产力范式的同时，彻底改写传统安全对抗逻辑。ISC.AI 2026 开幕式与未来峰会聚焦安全对抗由“人对人”转向“AI对AI”的核心变革，汇聚全球产业领袖与学界专家，深入剖析智能体技术演进引发的安全挑战及应对策略，共同探索安全智能体的创新发展路径，引领行业革命性突破。',
            start_date: '2026-06-24 14:00:00',
            end_date: '2026-06-24 16:30:00',
            address: '北京国家会议中心4F大会堂A',
            activity_type: '未来峰会',
            meet_date: '2026-06-24',
            date_type: '下午',
            video_url: 'https://isc.360.com/2020/detail.html？vid=6842',
            isShowDetail: true,
            agendas: [
                {
                    start_time: '14:00:00',
                    end_time: '14:20:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '潘剑锋',
                            is_compere: 0,
                            bio: '360集团首席科学家、集团高级副总裁',
                            image_url: 'https://p4.ssl.qhimg.com/t110b9a9301f6706751f3883f0e.png'
                        }
                    ]
                },
                {
                    start_time: '14:20:00',
                    end_time: '14:40:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '陈柏珲',
                            is_compere: 0,
                            bio: '亚洲数字经济科学院院长、美国国家人工智能科学院通讯院士',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a93010c6ccc8e95a92f3a.png'
                        }
                    ]
                },
                {
                    start_time: '14:40:00',
                    end_time: '15:00:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '殷宇辉',
                            is_compere: 0,
                            bio: '360集团高级副总裁、数智化集团CEO',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a9301a3a549792fcb27f5.png'
                        }
                    ]
                },
                {
                    start_time: '15:00:00',
                    end_time: '15:20:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '王耀华',
                            is_compere: 0,
                            bio: '统信软件技术有限公司副总裁',
                            image_url: 'https://p1.ssl.qhimg.com/t110b9a93013120781b1be00849.png'
                        }
                    ]
                },
                {
                    start_time: '15:20:00',
                    end_time: '15:40:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: 'Sergey Gordeychik',
                            is_compere: 0,
                            bio: 'Co-founder and CEO of CyberOK',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a9301b56867d3eb74ac9d.jpg'
                        }
                    ]
                },
                {
                    start_time: '15:40:00',
                    end_time: '16:00:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: 'Charles Lim',
                            is_compere: 0,
                            bio: 'Deputy Head of Master of IT Program Head of SOC、Swiss German University',
                            image_url: 'https://p5.ssl.qhimg.com/t110b9a93019d2b2457be6ae3c6.jpg'
                        }
                    ]
                },
                {
                    start_time: '16:00:00',
                    end_time: '16:30:00',
                    title: '圆桌讨论',
                    speakers: [
                        {
                            name: '主持人：陈柏珲',
                            is_compere: 1,
                            bio: '亚洲数字经济科学院院长、美国国家人工智能科学院通讯院士',
                            image_url: 'https://p1.ssl.qhimg.com/t110b9a93019d01bffa2d7d32f3.jpg'
                        },
                        {
                            name: '何帆',
                            is_compere: 0,
                            bio: '360集团城市产业副总裁、首席产品官、企业AI转型研究院院长',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a93019f0bc895ddc9e1cd.png'
                        },
                        {
                            name: '包红霞',
                            is_compere: 0,
                            bio: '安永（中国）企业咨询有限公司 科技咨询合伙人',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a93010127826e8f862a6b.png'
                        },
                        {
                            name: '马红杰',
                            is_compere: 0,
                            bio: '德勤中国网络安全咨询业务合伙人',
                            image_url: 'https://p1.ssl.qhimg.com/t110b9a93011d631613bce08c93.jpg'
                        },
                        {
                            name: '潘晓鸥',
                            is_compere: 0,
                            bio: '普华永道风险与监管业务管理咨询合伙人',
                            image_url: 'https://p5.ssl.qhimg.com/t110b9a9301c3381c4e8e993ccb.jpg'
                        }
                    ]
                }
            ]
        },
        {
            id: '003',
            title: '智启新程 伙伴同心——2026年360数字安全集团生态合作伙伴大会',
            description:'面对安全市场从单点突破向生态协同转型，如何以数智化能力赋能渠道、深化伙伴合作，成为激活省代战斗力与客户价值，跨越周期持续增长的核心命题。为此，360以“智启新程，伙伴同心”为主题，召开2026年360数字安全生态合作伙伴大会。以渠道政策加码、产品矩阵升级等核心举措，携手合作伙伴深耕区域市场，实现渠道效能与客户满意度全面跃升！',
            start_date: '2026-06-24 14:30:00',
            end_date: '2026-06-24 16:20:00',
            address: '北京国家会议中心311A',
            activity_type: '主题论坛',
            meet_date: '2026-06-24',
            date_type: '下午',
            video_url: 'https://isc.360.com/2020/detail.html？vid=6842',
            isShowDetail: true,
            agendas: [
                {
                    start_time: '14:30:00',
                    end_time: '14:40:00',
                    title: '领导致辞',
                    speakers: [
                        {
                            name: '胡振泉',
                            is_compere: 0,
                            bio: '360数字安全集团总裁',
                            image_url: 'https://p2.ssl.qhimg.com/t110b9a930117db9a9af1e175df.png'
                        }
                    ]
                },
                {
                    start_time: '14:40:00',
                    end_time: '15:00:00',
                    title: '政策宣贯',
                    speakers: [
                        {
                            name: '陈杨',
                            is_compere: 0,
                            bio: '360数字安全集团副总裁、标品事业部负责人',
                            image_url: 'https://p2.ssl.qhimg.com/t110b9a9301d4d3862e6e2242ce.png'
                        }
                    ]
                },
                {
                    start_time: '15:00:00',
                    end_time: '15:10:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '董强',
                            is_compere: 0,
                            bio: '北京汇志凌云数据技术有限责任公司总经理',
                            image_url: ''
                        }
                    ]
                },
                {
                    start_time: '15:10:00',
                    end_time: '15:20:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '刘灵灵',
                            is_compere: 0,
                            bio: '北京长得伟仕科技有限公司副总经理',
                            image_url: ''
                        }
                    ]
                },
                {
                    start_time: '15:20:00',
                    end_time: '15:30:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '赵爱华',
                            is_compere: 0,
                            bio: '北京众博豪科技有限公司副总经理',
                            image_url: ''
                        }
                    ]
                },
                {
                    start_time: '15:30:00',
                    end_time: '15:40:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '肖会波',
                            is_compere: 0,
                            bio: '360数字安全集团标品BU技术总监',
                            image_url: ''
                        }
                    ]
                },
                {
                    start_time: '15:40:00',
                    end_time: '15:50:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '余滔',
                            is_compere: 0,
                            bio: '360终端安全产品负责人',
                            image_url: ''
                        }
                    ]
                },
                {
                    start_time: '15:50:00',
                    end_time: '16:00:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '王斌',
                            is_compere: 0,
                            bio: '360安全合规产线负责人',
                            image_url: ''
                        }
                    ]
                },
                {
                    start_time: '16:00:00',
                    end_time: '16:10:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '胡晓娜',
                            is_compere: 0,
                            bio: '360城产集团高级副总裁、Ai事业发展部总经理、AikerWorld社区发起人',
                            image_url: ''
                        }
                    ]
                },
                {
                    start_time: '16:10:00',
                    end_time: '16:20:00',
                    title: '授牌仪式',
                    speakers: []
                }
            ]
        },
        {
            id: '004',
            title: '生态聚力，携手打造超级组织论坛',
            description:'今天，当AI技术突破通用智能的临界点，我们站在了又一个文明的岔路口：以Agent为核心的硅基力量，正在重新定义组织的底层逻辑。它不再满足于生成文本或图像，而是开始自主进化，能思考，能自主执行。将组织效率提升不止10倍以上。这场变革不止是技术迭代，更是生产力的底层革新，推动传统组织”正在不断向“超级组织”进化，成为AI发展不可阻挡的时代浪潮。在这样的时代背景下，360集团发起本次生态论坛。我们邀请全球AI技术专家、行业领军企业一起碰撞创新火花，与合作伙伴共同探索AI时代的组织新范式。携手站在技术创新与产业变革的最前沿，打造新生态、焕发新活力，与合作伙伴共同在AI浪潮下发展，为AI产业繁荣发展贡献中国力量。',
            start_date: '2026-06-24 14:00:00',
            end_date: '2026-06-24 16:55:00',
            address: '北京国家会议中心307AB',
            activity_type: '主题论坛',
            meet_date: '2026-06-24',
            date_type: '下午',
            video_url: 'https://isc.360.com/2020/detail.html？vid=6842',
            isShowDetail: true,
            agendas: [
                {
                    start_time: '14:00:00',
                    end_time: '14:05:00',
                    title: '主持人开场',
                    speakers: []
                },
                {
                    start_time: '14:05:00',
                    end_time: '14:25:00',
                    title: '领导致辞',
                    speakers: [
                        {
                            name: '叶健',
                            is_compere: 0,
                            bio: '360集团首席运营官',
                            image_url: 'https://p4.ssl.qhimg.com/t110b9a930173cc0207869d698e.png'
                        }
                    ]
                },
                {
                    start_time: '14:25:00',
                    end_time: '14:45:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '梁志辉',
                            is_compere: 0,
                            bio: '360集团副总裁',
                            image_url: 'https://p5.ssl.qhimg.com/t110b9a9301306cf3848c48402a.jpg'
                        }
                    ]
                },
                {
                    start_time: '14:45:00',
                    end_time: '15:05:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '廖百成',
                            is_compere: 0,
                            bio: '360数智化集团首席解决方案架构师',
                            image_url: 'https://p0.ssl.qhimg.com/t110b9a93010826920407590783.png'
                        }
                    ]
                },
                {
                    start_time: '15:05:00',
                    end_time: '15:25:00',
                    title: '产品发布&主题演讲',
                    speakers: [
                        {
                            name: '何帆',
                            is_compere: 0,
                            bio: '360集团城市产业副总裁、首席产品官、企业AI转型研究院院长',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a93019f0bc895ddc9e1cd.png'
                        },
                        {
                            name: '赵威',
                            is_compere: 0,
                            bio: '360集团城市产业高级总监',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a930137fdd837545ba06f.jpg'
                        }
                    ]
                },
                {
                    start_time: '15:25:00',
                    end_time: '15:35:00',
                    title: '签约仪式',
                    speakers: []
                },
                {
                    start_time: '15:35:00',
                    end_time: '15:55:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '周信宏',
                            is_compere: 0,
                            bio: '中国惠普有限公司副总裁',
                            image_url: 'https://p4.ssl.qhimg.com/t110b9a9301e91dbfcbcc5a22fe.jpg'
                        }
                    ]
                },
                {
                    start_time: '15:55:00',
                    end_time: '16:15:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '康晓宇',
                            is_compere: 0,
                            bio: '华为云伙伴与生态部总裁',
                            image_url: 'https://p2.ssl.qhimg.com/t110b9a9301a22feeda304932e7.jpg'
                        }
                    ]
                },
                {
                    start_time: '16:15:00',
                    end_time: '16:35:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '应华江',
                            is_compere: 0,
                            bio: '北明软件有限公司总裁',
                            image_url: 'https://p5.ssl.qhimg.com/t110b9a9301aea9c014cacc0124.jpg'
                        }
                    ]
                },
                {
                    start_time: '16:35:00',
                    end_time: '16:55:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '戴敏',
                            is_compere: 0,
                            bio: '南天信息首席技术官',
                            image_url: 'https://p0.ssl.qhimg.com/t110b9a93012ac474a27ac4db53.jpg'
                        }
                    ]
                }
            ]
        },
        {
            id: '005',
            title: 'AINative安全智能体-迈向智能体驱动的安全时代论坛',
            description:'随着大模型、AIAgent（智能体）以及自动化技术的快速发展，人工智能正在从“辅助工具”逐步演变为具备自主感知、分析、决策与执行能力的新型生产力。特别是在网络安全领域，安全智能体正推动安全运营体系从“人工驱动”向“AINative”模式演进，成为行业关注的重要方向。当前，企业在安全运营过程中普遍面临告警量激增、攻击手法复杂化、安全人才不足以及响应效率低等问题。基于大模型与智能体技术的新一代安全体系，正在逐步实现从威胁检测、攻击分析、自动研判，到自动化处置与协同运营的能力升级。安全智能体不仅能够提升安全运营效率，还将重构未来SOC、安全分析、安全运营及攻防协同体系。本论坛将围绕“安全智能体行业应用”主题，重点聚焦AIAgent在网络安全场景中的落地实践，涵盖安全运营智能体、威胁分析智能体、自动化响应、AI驱动SOC、智能攻防协同、安全知识库、大模型安全等热点方向。论坛将邀请行业专家、安全厂商、科研机构及企业安全团队，共同探讨安全智能体的技术趋势、行业应用与未来发展路径，推动人工智能与网络安全深度融合，加速安全行业智能化升级。',
            start_date: '2026-06-24 14:00:00',
            end_date: '2026-06-24 16:25:00',
            address: '北京国家会议中心308',
            activity_type: '主题论坛',
            meet_date: '2026-06-24',
            date_type: '下午',
            video_url: 'https://isc.360.com/2020/detail.html？vid=6842',
            isShowDetail: true,
            agendas: [
                {
                    start_time: '14:00:00',
                    end_time: '14:05:00',
                    title: '开场致辞',
                    speakers: [
                        {
                            name: '张锦章',
                            is_compere: 0,
                            bio: '360数字安全集团副总裁',
                            image_url: 'https://p1.ssl.qhimg.com/t110b9a9301ccf03940d3ea25fc.jpg'
                        }
                    ]
                },
                {
                    start_time: '14:05:00',
                    end_time: '14:25:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '孔祥焱',
                            is_compere: 0,
                            bio: '360数字安全集团终端产品部总经理',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a93013d4a4eea266199f3.png'
                        }
                    ]
                },
                {
                    start_time: '14:25:00',
                    end_time: '14:45:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '王海波',
                            is_compere: 0,
                            bio: '360数字安全集团副总裁',
                            image_url: 'https://p4.ssl.qhimg.com/t110b9a9301966e23ced60d7652.png'
                        }
                    ]
                },
                {
                    start_time: '14:45:00',
                    end_time: '15:05:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '郭亮',
                            is_compere: 0,
                            bio: '360数字安全集团本地安全大脑研发负责人',
                            image_url: 'https://p4.ssl.qhimg.com/t110b9a93015c26064b5040c222.jpg'
                        }
                    ]
                },
                {
                    start_time: '15:05:00',
                    end_time: '15:25:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '李薛',
                            is_compere: 0,
                            bio: '360数字安全集团高级总监',
                            image_url: 'https://p0.ssl.qhimg.com/t110b9a93018418aa249d23607d.png'
                        }
                    ]
                },
                {
                    start_time: '15:25:00',
                    end_time: '15:45:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '周立天',
                            is_compere: 0,
                            bio: '北京兴云数科技术有限公司信息安全总监',
                            image_url: 'https://p2.ssl.qhimg.com/t110b9a93013de472aeac65f14f.jpg'
                        }
                    ]
                },
                {
                    start_time: '15:45:00',
                    end_time: '16:05:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '刘益铭',
                            is_compere: 0,
                            bio: '天翼云科技有限公司高级信息安全工程师',
                            image_url: 'https://p5.ssl.qhimg.com/t110b9a9301323eeb48ea204e34.jpg'
                        }
                    ]
                },
                {
                    start_time: '16:05:00',
                    end_time: '16:25:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '叶家明',
                            is_compere: 0,
                            bio: '360数字安全集团企业浏览器产品负责人',
                            image_url: 'https://p0.ssl.qhimg.com/t110b9a9301a53f6b4e06117a41.jpg'
                        }
                    ]
                }
            ]
        },
        {
            id: '006',
            title: 'AI落地加速：企业场景全面开局——从技术底座到行业场景的实干之路论坛',
            description:'AI不再只停留在概念展示，真正的落地战已经进入企业核心场景。面对高复杂、高要求、高协同的业务环境，AI能否真正跑进流程、解决问题，并带来可衡量的价值，正在成为企业数智化升级的关键命题。政务服务，能否真正实现“服务直达“？航司业务低容错要求下，智能体能否可靠上岗？智慧医疗走向真实临床与服务场景，效果如何验证？法务知识管理沉淀成库，AI正在破解哪些难题？AI教育进入加速度，智能体落地再出哪些新亮点？ISC数智行业分论坛，聚焦政务、航司、医疗、法务、教育等高复杂度场景，邀请产业专家与一线实践者，呈现AI从技术底座到行业场景的真实落地样本，拆解从单点工具到全局Agent的演进路径，带来可参考、可复制、可规模化的实战经验。',
            start_date: '2026-06-24 14:00:00',
            end_date: '2026-06-24 16:30:00',
            address: '北京国家会议中心309A',
            activity_type: '主题论坛',
            meet_date: '2026-06-24',
            date_type: '下午',
            video_url: 'https://isc.360.com/2020/detail.html？vid=6842',
            isShowDetail: true,
            agendas: [
                {
                    start_time: '14:00:00',
                    end_time: '14:05:00',
                    title: '开场致辞',
                    speakers: [
                        {
                            name: '殷宇辉',
                            is_compere: 0,
                            bio: '360集团高级副总裁、数智化集团CEO',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a9301a3a549792fcb27f5.png'
                        }
                    ]
                },
                {
                    start_time: '14:05:00',
                    end_time: '14:10:00',
                    title: '开场致辞',
                    speakers: [
                        {
                            name: '董志毅',
                            is_compere: 0,
                            bio: '中国航空学会低空经济首席专家',
                            image_url: 'https://p5.ssl.qhimg.com/t110b9a93011c26972893cc85c0.jpg'
                        }
                    ]
                },
                {
                    start_time: '14:10:00',
                    end_time: '14:15:00',
                    title: '开场致辞',
                    speakers: [
                        {
                            name: '范丛明',
                            is_compere: 0,
                            bio: '全国工商联人工智能委员会常务秘书长、深圳市人工智能产业协会执行会长',
                            image_url: 'https://p0.ssl.qhimg.com/t110b9a93019c014c170266770b.png'
                        }
                    ]
                },
                {
                    start_time: '14:15:00',
                    end_time: '14:30:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '高磊',
                            is_compere: 0,
                            bio: '360数智化集团副总裁',
                            image_url: 'https://p4.ssl.qhimg.com/t110b9a93017d1c99d164dfd330.png'
                        }
                    ]
                },
                {
                    start_time: '14:30:00',
                    end_time: '14:45:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '李方翔',
                            is_compere: 0,
                            bio: '360数智化集团首席解决方案架构师',
                            image_url: 'https://p0.ssl.qhimg.com/t110b9a930145f40c32d77616d1.png'
                        }
                    ]
                },
                {
                    start_time: '14:45:00',
                    end_time: '15:00:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '严超',
                            is_compere: 0,
                            bio: '360数智化集团高级产品总监',
                            image_url: 'https://p2.ssl.qhimg.com/t110b9a9301cf9d931a53397588.png'
                        }
                    ]
                },
                {
                    start_time: '15:00:00',
                    end_time: '15:15:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '燕江依',
                            is_compere: 0,
                            bio: '信通院人工智能研究所研究员',
                            image_url: 'https://p0.ssl.qhimg.com/t110b9a9301dbbb8e16121b654e.jpg'
                        }
                    ]
                },
                {
                    start_time: '15:15:00',
                    end_time: '15:30:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '戴明明',
                            is_compere: 0,
                            bio: '安徽惠丰科技有限公司AI事业部总经理',
                            image_url: 'https://p5.ssl.qhimg.com/t110b9a93013f52b1339c75c71f.jpg'
                        }
                    ]
                },
                {
                    start_time: '15:30:00',
                    end_time: '15:45:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '查玉龙',
                            is_compere: 0,
                            bio: '青岛市妇女儿童医院信息中心主任',
                            image_url: 'https://p0.ssl.qhimg.com/t110b9a9301049b050a4aab8510.png'
                        }
                    ]
                },
                {
                    start_time: '15:45:00',
                    end_time: '16:00:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '李博文',
                            is_compere: 0,
                            bio: '中闻律师事务所合伙人',
                            image_url: 'https://p4.ssl.qhimg.com/t110b9a9301e060bb51318d660d.jpg'
                        }
                    ]
                },
                {
                    start_time: '16:00:00',
                    end_time: '16:15:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '崔良玉',
                            is_compere: 0,
                            bio: '大庆华术信息科技有限公司 总经理',
                            image_url: 'https://p1.ssl.qhimg.com/t110b9a93018b635a21db5be065.jpg'
                        }
                    ]
                },
                {
                    start_time: '16:15:00',
                    end_time: '16:30:00',
                    title: '2026年360数智化颁奖典礼',
                    speakers: []
                }
            ]
        },
        {
            id: '007',
            title: 'AI安全运营：安全智能体与智能体安全变奏交响论坛',
            description:'全产业智能化纵深推进，AI正从攻防两端重构安全博弈：攻击侧黑产呈工业化特征，防守侧风险从网络、数据泄露延伸至模型与智能体链路等AI原生层面。传统规则驱动防御难以为继，AI安全运营亟需打破桎梏，践行“以模治模”主旋律，演绎「AI for Security」与「Security for AI」的变奏交响。本论坛基于双轨技术体系，演绎协奏乐章：AI for Security，依托安全智能体实现传统安全运营能力跨越式突破，重塑看见、处置与知识全流程，突破规则天花板，迈向自主执行的“自动驾驶”；Security for AI，强化智能体安全，深耕权限滥用、代理逃逸等原生风险治理，构建全生命周期安全闭环。论坛聚焦双轨协同底层逻辑——以安全智能体赋能运营，以安全能力守护智能体涌现。旨在持续增加安全“AI含量”，推动从成本中心向价值创造中心转变，为构建新一代智能安全运营体系提供专业参考。',
            start_date: '2026-06-24 14:00:00',
            end_date: '2026-06-24 16:35:00',
            address: '北京国家会议中心309B',
            activity_type: '主题论坛',
            meet_date: '2026-06-24',
            date_type: '下午',
            video_url: 'https://isc.360.com/2020/detail.html？vid=6842',
            isShowDetail: true,
            agendas: [
                {
                    start_time: '14:00:00',
                    end_time: '14:10:00',
                    title: '开场致辞',
                    speakers: [
                        {
                            name: '余凯',
                            is_compere: 0,
                            bio: '360数字安全集团副总裁',
                            image_url: 'https://p1.ssl.qhimg.com/t110b9a9301920edec60c07177d.png'
                        }
                    ]
                },
                {
                    start_time: '14:10:00',
                    end_time: '14:15:00',
                    title: '领导致辞',
                    speakers: [
                        {
                            name: '严明',
                            is_compere: 0,
                            bio: '中国计算学会计算机安全专业委员会主任',
                            image_url: 'https://p1.ssl.qhimg.com/t110b9a93011a7ae2410d654e1e.jpg'
                        }
                    ]
                },
                {
                    start_time: '14:15:00',
                    end_time: '14:35:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '谭晓生',
                            is_compere: 0,
                            bio: '北京赛博英杰科技有限公司创始人兼CEO',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a930156641fa90da00edc.png'
                        }
                    ]
                },
                {
                    start_time: '14:35:00',
                    end_time: '14:55:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '王同良',
                            is_compere: 0,
                            bio: '中国计算机用户协会副理事长、中国海洋石油集团有限公司特聘专家',
                            image_url: 'https://p1.ssl.qhimg.com/t110b9a9301e9f39c7df9ffef9e.png'
                        }
                    ]
                },
                {
                    start_time: '14:55:00',
                    end_time: '15:15:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '冯豪',
                            is_compere: 0,
                            bio: '宁波市数据局基础设施与安全处处长',
                            image_url: 'https://p2.ssl.qhimg.com/t110b9a93014ebdcf7627f41129.jpg'
                        }
                    ]
                },
                {
                    start_time: '15:15:00',
                    end_time: '15:35:00',
                    title: '产品发布',
                    speakers: [
                        {
                            name: '邵菊',
                            is_compere: 0,
                            bio: '360数字安全集团产品总监',
                            image_url: 'https://p0.ssl.qhimg.com/t110b9a930144f26163fdd96355.jpg'
                        }
                    ]
                },
                {
                    start_time: '15:35:00',
                    end_time: '15:55:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '张睿',
                            is_compere: 0,
                            bio: '360集团信息安全中心总经理',
                            image_url: 'https://p4.ssl.qhimg.com/t110b9a93015eecc3f4188b2f2f.png'
                        }
                    ]
                },
                {
                    start_time: '15:55:00',
                    end_time: '16:15:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '刘畅',
                            is_compere: 0,
                            bio: '360数字安全集团技术总监',
                            image_url: 'https://p0.ssl.qhimg.com/t110b9a930122588c009b448482.jpg'
                        }
                    ]
                },
                {
                    start_time: '16:15:00',
                    end_time: '16:35:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '宋志明',
                            is_compere: 0,
                            bio: '天翼云科技有限公司安全产品线总经理',
                            image_url: 'https://p5.ssl.qhimg.com/t110b9a9301bdd91baf52df8b2d.png'
                        }
                    ]
                }
            ]
        },
        {
            id: '008',
            title: 'AI赋能政企安全创新论坛',
            description:'随着数字化进程的深入，人工智能已成为政企发展的新生产力，但也伴生出全新的网络攻击面。为助力机构构建智能化的防御体系，“AI赋能政企安全创新论坛”即将拉开帷幕。本论坛聚焦前沿探索与落地应用，深入剖析人工智能赋能网络安全研究与工程实践的有效路径；并借由企业的AI创新防护与安全治理实践，为您提供实战参考。同时，论坛将重点探讨如何以人工智能构建并赋能可信数据空间，从而全面支撑政企数据的安全授权与运营。',
            start_date: '2026-06-24 14:00:00',
            end_date: '2026-06-24 15:30:00',
            address: '北京国家会议中心306AB',
            activity_type: '主题论坛',
            meet_date: '2026-06-24',
            date_type: '下午',
            video_url: 'https://isc.360.com/2020/detail.html？vid=6842',
            isShowDetail: true,
            agendas: [
                {
                    start_time: '14:00:00',
                    end_time: '14:05:00',
                    title: '领导致辞',
                    speakers: [
                        {
                            name: '王同良',
                            is_compere: 0,
                            bio: '中国计算机用户协会副理事长、中国海洋石油集团有限公司特聘专家',
                            image_url: 'https://p1.ssl.qhimg.com/t110b9a9301e9f39c7df9ffef9e.png'
                        }
                    ]
                },
                {
                    start_time: '14:05:00',
                    end_time: '14:10:00',
                    title: '领导致辞',
                    speakers: [
                        {
                            name: '胡振泉',
                            is_compere: 0,
                            bio: '360数字安全集团总裁',
                            image_url: 'https://p2.ssl.qhimg.com/t110b9a930117db9a9af1e175df.png'
                        }
                    ]
                },
                {
                    start_time: '14:10:00',
                    end_time: '14:30:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '张志强',
                            is_compere: 0,
                            bio: '北汽福田汽车股份有限公司，全球信息安全负责人&DPO',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a9301f34abe0c4be5bd03.jpg'
                        }
                    ]
                },
                {
                    start_time: '14:30:00',
                    end_time: '14:50:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '张念彬',
                            is_compere: 0,
                            bio: '清华大学教授',
                            image_url: 'https://p0.ssl.qhimg.com/t110b9a9301bfb64bea6e9aca9f.jpg'
                        }
                    ]
                },
                {
                    start_time: '14:50:00',
                    end_time: '15:10:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '贾宇',
                            is_compere: 0,
                            bio: '山石网科通信技术股份有限公司副总裁 ',
                            image_url: 'https://p1.ssl.qhimg.com/t110b9a9301f3509c42f2629ac2.png'
                        }
                    ]
                },
                {
                    start_time: '15:10:00',
                    end_time: '15:30:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '张景龙',
                            is_compere: 0,
                            bio: '360数字安全集团行业解决方案负责人',
                            image_url: 'https://p2.ssl.qhimg.com/t110b9a93015d07d377b52cc47d.png'
                        }
                    ]
                }
            ]
        },
        {
            id: '009',
            title: '第四届全国信息安全产教融合共同体发展大会',
            description:'为深入贯彻国家人工智能发展战略，响应教育数字化安全领域核心需求，落实教育部等五部门联合印发的《“人工智能+教育”行动计划》相关要求，推动人工智能技术赋能教育变革，第四届全国信息安全产教融合共同体发展大会围绕“AI育才，数智兴校”主题，聚焦强化产教融合可视化成果交付，为构建安全可信的人工智能教育生态提供可落地的实施框架。',
            start_date: '2026-06-24 13:30:00',
            end_date: '2026-06-24 17:30:00',
            address: '北京国家会议中心311B',
            activity_type: '主题论坛',
            meet_date: '2026-06-24',
            date_type: '下午',
            video_url: 'https://isc.360.com/2020/detail.html？vid=6842',
            isShowDetail: true,
            agendas: [
                {
                    start_time: '13:30:00',
                    end_time: '13:35:00',
                    title: '领导致辞',
                    speakers: [
                        {
                            name: '刘明亮',
                            is_compere: 0,
                            bio: '工业和信息化部教育考试中心党总支副书记、副主任',
                            image_url: ''
                        }
                    ]
                },
                {
                    start_time: '13:35:00',
                    end_time: '13:40:00',
                    title: '领导致辞',
                    speakers: [
                        {
                            name: '封化民',
                            is_compere: 0,
                            bio: '教育部网络空间安全教学指导委员会秘书长',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a9301d571dd95e7bc4529.png'
                        }
                    ]
                },
                {
                    start_time: '13:40:00',
                    end_time: '13:45:00',
                    title: '领导致辞',
                    speakers: [
                        {
                            name: '卜思南',
                            is_compere: 0,
                            bio: '360数字安全集团副总裁、ISC.AI主理人',
                            image_url: 'https://p4.ssl.qhimg.com/t110b9a930167afd1fab327693c.png'
                        }
                    ]
                },
                {
                    start_time: '13:45:00',
                    end_time: '13:50:00',
                    title: '领导致辞',
                    speakers: [
                        {
                            name: '洪伟',
                            is_compere: 0,
                            bio: '北京信息职业技术学院党委副书记、校长',
                            image_url: 'https://p4.ssl.qhimg.com/t110b9a9301730b36381e63dd57.jpg'
                        }
                    ]
                },
                {
                    start_time: '13:50:00',
                    end_time: '14:30:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '王春燕',
                            is_compere: 0,
                            bio: '北京教育科学研究院研究员',
                            image_url: 'https://p4.ssl.qhimg.com/t110b9a9301d43889d04b8ad6f5.jpg'
                        }
                    ]
                },
                {
                    start_time: '14:30:00',
                    end_time: '14:50:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '马晓丽',
                            is_compere: 0,
                            bio: '石家庄信息工程职业学院软件工程学院院长',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a9301a9db3b3f14e801fe.png'
                        }
                    ]
                },
                {
                    start_time: '14:50:00',
                    end_time: '15:10:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '朱成波',
                            is_compere: 0,
                            bio: '青岛恒星科技学院数智学院党总支书记',
                            image_url: 'https://p0.ssl.qhimg.com/t110b9a93019aa03e8ec901135c.png'
                        }
                    ]
                },
                {
                    start_time: '15:10:00',
                    end_time: '15:30:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '王旭',
                            is_compere: 0,
                            bio: '360数字安全集团教育事业部教研总监',
                            image_url: 'https://p0.ssl.qhimg.com/t110b9a9301a3d968d60b6ee303.png'
                        }
                    ]
                },
                {
                    start_time: '15:30:00',
                    end_time: '15:50:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '高献光',
                            is_compere: 0,
                            bio: '360数智化集团高级技术总监',
                            image_url: 'https://p2.ssl.qhimg.com/t110b9a930176b28acd22861b18.png'
                        }
                    ]
                },
                {
                    start_time: '15:50:00',
                    end_time: '16:10:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '李运通',
                            is_compere: 0,
                            bio: '陕西铁路工程职业技术学院信息化负责人',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a930147df22f3c1dc4735.jpg'
                        }
                    ]
                },
                {
                    start_time: '16:10:00',
                    end_time: '16:25:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '陈宇扬',
                            is_compere: 0,
                            bio: '广东智慧青少年宫教育发展有限公司总裁、中国环境资源集团教育产业负责人',
                            image_url: 'https://p2.ssl.qhimg.com/t110b9a9301f1538216bc7d2a8c.png'
                        }
                    ]
                },
                {
                    start_time: '16:25:00',
                    end_time: '16:45:00',
                    title: 'ISC.AI人才计划启动仪式 <br>ISC.AI2026创新独角兽沙盒大赛高校创新新星赛颁奖仪式 <br>360教育生态合作伙伴授牌仪式',
                    speakers: []
                },
                {
                    start_time: '16:45:00',
                    end_time: '17:30:00',
                    title: '圆桌对话',
                    speakers: [
                        {
                            name: '主持人：武春岭',
                            is_compere: 1,
                            bio: '重庆电子科技职业大学人工智能与大数据学院院长',
                            image_url: 'https://p0.ssl.qhimg.com/t110b9a930168dda5efe56b12ba.jpg'
                        },
                        {
                            name: '李丽',
                            is_compere: 0,
                            bio: '川能智网数安事业部&天府数智技能孵化园总经理',
                            image_url: 'https://p5.ssl.qhimg.com/t110b9a9301f280140bfaad2177.png'
                        },
                        {
                            name: '唐慧',
                            is_compere: 0,
                            bio: '广州腾科网络技术有限公司总经理',
                            image_url: 'https://p5.ssl.qhimg.com/t110b9a93017f4bc5b42bfe50ee.jpg'
                        },
                        {
                            name: '王隆杰',
                            is_compere: 0,
                            bio: '深圳职业技术大学教授',
                            image_url: 'https://p3.ssl.qhimg.com/t110b9a9301b2e7a720788310fc.jpg'
                        },
                        {
                            name: '吴松丽',
                            is_compere: 0,
                            bio: '驻马店职业技术学教务处处长、信息工程学院院长',
                            image_url: 'https://p2.ssl.qhimg.com/t110b9a930192ea81b2999d19b0.png'
                        }
                    ]
                }
            ]
        },
        {
            id: '010',
            title: '「智弈」AI智能体攻防实战沙龙',
            description:'ISC 2026大会期间，「智弈」AI智能体攻防实战沙龙将于6月24日下午在北京国家会议中心302举行。沙龙聚焦AI Agent安全前沿，汇聚360、百度及安全社区一线专家，围绕链式逃逸、智能体漏洞挖掘、免杀投毒、Agent安全加固、SOC智能化转型等议题展开深度技术分享，并设圆桌讨论共探产业趋势，共话智能体安全新局.',
            start_date: '2026-06-24 14:00:00',
            end_date: '2026-06-24 18:30:00',
            address: '北京国家会议中心302',
            activity_type: '主题论坛',
            meet_date: '2026-06-24',
            date_type: '下午',
            video_url: 'https://isc.360.com/2020/detail.html？vid=6842',
            isShowDetail: true,
            agendas: [
                {
                    start_time: '14:00:00',
                    end_time: '14:10:00',
                    title: '开场致辞',
                    speakers: []
                },
                {
                    start_time: '14:10:00',
                    end_time: '14:40:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: 'w1th0ut',
                            is_compere: 0,
                            bio: '',
                            image_url: ''
                        }
                    ]
                },
                {
                    start_time: '14:40:00',
                    end_time: '15:10:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '陈永锋',
                            is_compere: 0,
                            bio: '',
                            image_url: ''
                        }
                    ]
                },
                {
                    start_time: '15:10:00',
                    end_time: '15:40:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '半夜不睡觉',
                            is_compere: 0,
                            bio: '',
                            image_url: ''
                        }
                    ]
                },
                {
                    start_time: '15:40:00',
                    end_time: '16:00:00',
                    title: '互动活动',
                    speakers: []
                },
                {
                    start_time: '16:00:00',
                    end_time: '16:30:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '曹新宇',
                            is_compere: 0,
                            bio: '',
                            image_url: ''
                        }
                    ]
                },
                {
                    start_time: '16:30:00',
                    end_time: '17:00:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '汤天海（Loki）',
                            is_compere: 0,
                            bio: '',
                            image_url: ''
                        }
                    ]
                },
                {
                    start_time: '17:00:00',
                    end_time: '17:50:00',
                    title: '主题演讲',
                    speakers: [
                        {
                            name: '张睿',
                            is_compere: 0,
                            bio: '',
                            image_url: ''
                        },
                        {
                            name: '曹新宇',
                            is_compere: 0,
                            bio: '',
                            image_url: ''
                        },
                        {
                            name: '淚笑',
                            is_compere: 0,
                            bio: '',
                            image_url: ''
                        },
                        {
                            name: '半夜不睡觉',
                            is_compere: 0,
                            bio: '',
                            image_url: ''
                        },
                        {
                            name: '陈永锋',
                            is_compere: 0,
                            bio: '',
                            image_url: ''
                        },
                        {
                            name: '宁宇飞',
                            is_compere: 0,
                            bio: '',
                            image_url: ''
                        },
                        {
                            name: '胡晓娜',
                            is_compere: 0,
                            bio: '',
                            image_url: ''
                        },
                    ]
                },
                {
                    start_time: '17:50:00',
                    end_time: '18:00:00',
                    title: '互动活动',
                    speakers: []
                },
                {
                    start_time: '18:00:00',
                    end_time: '18:30:00',
                    title: '自由交流',
                    speakers: []
                }
            ]
        },
        {
            id: '011',
            title: '智能体构筑安全防御体系论坛（闭门）',
            description:'随着AI技术深度融入网络攻防场景，网络安全对抗迈入智能化、自动化、体系化的全新阶段，传统被动防御模式已难以应对高阶、高频、多变的网络威胁。在此背景下，智能体构建网络防御体系论坛聚焦AI安全智能体前沿技术与落地应用，汇聚360安全领域专家，围绕智能体驱动的新型网络防御体系建设展开深度研讨，助力行业突破传统安全运营瓶颈，构建主动、协同、高效的数智化防御新格局。论坛聚焦四大核心议题，兼顾技术架构、落地实践、攻防对抗与威胁溯源，全方位覆盖智能体网络防御全链条能力建设。其中，安全大数据智能体实践主题，聚焦海量安全数据的智能分析、研判与应用，分享大数据智能体在威胁筛查、态势感知、安全运营中的落地经验，破解数据利用率低、研判效率不足等行业痛点。渗透测试智能体专题，围绕自动化、智能化渗透攻防技术展开，探讨智能体在风险验证、攻防演练中的应用场景，革新传统人工渗透测试模式，提升攻防对抗精准度与效率。',
            start_date: '2026-06-24 14:00:00',
            end_date: '2026-06-24 17:30:00',
            address: '北京国家会议中心310',
            activity_type: '闭门论坛',
            meet_date: '2026-06-24',
            date_type: '下午',
            video_url: null,
            isShowDetail: false
        }
    ]
}

export const agendaInfo = {
    "titleCn": "大会日程",
    "titleEn": "MEETING SCHEDULE",
    "list": [
        {
            "date": "6月24日",
            "title": "",
            "time": "09:00~18:00",
            "info": [
                {
                    "title": "全部",
                    "children": [
                        {
                            "time": "上午",
                            "detail": [
                                {
                                    "title": "开幕式与未来峰会",
                                    "place": "北京国家会议中心-4F大会堂A",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=001"
                                }
                            ]
                        },
                        {
                            "time": "下午",
                            "detail": [
                                {
                                    "title": "未来峰会",
                                    "place": "北京国家会议中心-4F大会堂A",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=002"
                                },
                                {
                                    "title": "智启新程 伙伴同心——2026年360数字安全集团生态合作伙伴大会",
                                    "place": "北京国家会议中心-311A",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=003"
                                },
                                {
                                    "title": "生态聚力，携手打造超级组织论坛",
                                    "place": "北京国家会议中心-307AB",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=004"
                                },
                                {
                                    "title": "AINative安全智能体-迈向智能体驱动的安全时代论坛",
                                    "place": "北京国家会议中心-308",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=005"
                                },
                                {
                                    "title": "AI落地加速：企业场景全面开局——从技术底座到行业场景的实干之路论坛",
                                    "place": "北京国家会议中心-309A",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=006"
                                },
                                {
                                    "title": "AI安全运营：安全智能体与智能体安全变奏交响论坛",
                                    "place": "北京国家会议中心-309B",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=007"
                                },
                                {
                                    "title": "AI赋能政企安全创新论坛",
                                    "place": "北京国家会议中心-306AB",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=008"
                                },
                                {
                                    "title": "第四届全国信息安全产教融合共同体发展大会",
                                    "place": "北京国家会议中心-311B",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=009"
                                },
                                {
                                    "title": "「智弈」AI智能体攻防实战沙龙",
                                    "place": "北京国家会议中心-302",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=010"
                                },
                                {
                                    "title": "智能体构筑安全防御体系论坛（闭门）",
                                    "place": "北京国家会议中心-310",
                                    "path": ""
                                },
                                {
                                    "title": "ISC.AI 2026红衣课堂",
                                    "place": "北京国家会议中心-3F报告厅",
                                    "path": ""
                                },
                                {
                                    "title": "ISC.AI 2026创新独角兽沙盒大赛——数字安全创新赛道&AI应用创新赛道",
                                    "place": "北京国家会议中心-301会议室",
                                    "path": ""
                                },
                                {
                                    "title": "ISC.AI Agent Teams",
                                    "place": "北京国家会议中心-3F序厅",
                                    "path": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "title": "开幕式&未来峰会",
                    "children": [
                        {
                            "time": "上午",
                            "detail": [
                                {
                                    "title": "开幕式与未来峰会",
                                    "place": "北京国家会议中心-4F大会堂A",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=001"
                                }
                            ]
                        },
                        {
                            "time": "下午",
                            "detail": [
                                {
                                    "title": "未来峰会",
                                    "place": "北京国家会议中心-4F大会堂A",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=002"
                                }
                            ]
                        }
                    ]
                },
                {
                    "title": "主题论坛",
                    "children": [
                        {
                            "time": "下午",
                            "detail": [
                                {
                                    "title": "智启新程 伙伴同心——2026年360数字安全集团生态合作伙伴大会",
                                    "place": "北京国家会议中心-311A",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=003"    
                                },
                                {
                                    "title": "生态聚力，携手打造超级组织论坛",
                                    "place": "北京国家会议中心-307AB",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=004"
                                },
                                {
                                    "title": "AINative安全智能体-迈向智能体驱动的安全时代论坛",
                                    "place": "北京国家会议中心-308",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=005"
                                },
                                {
                                    "title": "AI落地加速：企业场景全面开局——从技术底座到行业场景的实干之路论坛",
                                    "place": "北京国家会议中心-309A",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=006"
                                },
                                {
                                    "title": "AI安全运营：安全智能体与智能体安全变奏交响论坛",
                                    "place": "北京国家会议中心-309B",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=007"
                                },
                                {
                                    "title": "AI赋能政企安全创新论坛",
                                    "place": "北京国家会议中心-306AB",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=008"
                                },
                                {
                                    "title": "第四届全国信息安全产教融合共同体发展大会",
                                    "place": "北京国家会议中心-311B",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=009"
                                },
                                {
                                    "title": "「智弈」AI智能体攻防实战沙龙",
                                    "place": "北京国家会议中心-302",
                                    "path": "https://isc.360.com/new/2026/agenda/detail.html?id=010"
                                },
                                {
                                    "title": "智能体构筑安全防御体系论坛（闭门）",
                                    "place": "北京国家会议中心-310",
                                    "path": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "title": "特色活动",
                    "children": [
                        {
                            "time": "下午",
                            "detail": [
                                {
                                    "title": "ISC.AI 2026红衣课堂",
                                    "place": "北京国家会议中心-3F报告厅",
                                    "path": ""
                                },
                                {
                                    "title": "ISC.AI 2026创新独角兽沙盒大赛——数字安全创新赛道&AI应用创新赛道",
                                    "place": "北京国家会议中心-301会议室",
                                    "path": ""
                                },
                                {
                                    "title": "ISC.AI Agent Teams",
                                    "place": "北京国家会议中心-3F序厅",
                                    "path": ""
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}
